import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../Navbar/Navbar";
import Sidebar from "./Sidebar";

const MainLayout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    const savedState = localStorage.getItem("sidebar-open");
    return savedState !== null ? JSON.parse(savedState) : false;
  });

  useEffect(() => {
    localStorage.setItem("sidebar-open", JSON.stringify(isSidebarOpen));
  }, [isSidebarOpen]);

  return (
    <div className="min-h-screen bg-gray-50/80">
      <div className="fixed inset-x-0 top-0 z-50 h-16">
        <Navbar sidebarOpen={isSidebarOpen} />
      </div>

      <Sidebar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />

      {/* Clears the fixed navbar above and the fixed sidebar to its left. The
          minimum height leaves room for that padding, so a short page fills the
          viewport exactly instead of scrolling by the height of the navbar. */}
      <main
        className={`min-h-[calc(100vh-4rem)] pt-16 transition-[margin] duration-300 ease-in-out
          ${isSidebarOpen ? "ml-64" : "ml-[4.5rem]"}`}
      >
        <div className="mx-auto max-w-[1600px] p-6 lg:p-8">{children || <Outlet />}</div>
      </main>
    </div>
  );
};

export default MainLayout;
